import React from 'react';
import VariantFooter from './variants/VariantFooter';

const VariantFooterWrapper = () => {
  return <VariantFooter />;
};

export default VariantFooterWrapper;
